import { TemplateEngine } from "../../../../js/lib/TemplateEngine";
import { ApplicationData } from "../ApplicationData";

export class LocationSelectorControl {
  constructor(options) {
    this.id = options.id;
    this.selectOptionTmpl = "tmpl/controls/locationSelectorOption.html";
  }
  render(callback) {
    const limitsWithoutHidden = ApplicationData.branchLimitsUtil.getLimitsWithoutHidden();
    const branchIds = ApplicationData.branchLimitsUtil.getDisplayInPickupLocationIds();
    this.locationOptions = $.grep(limitsWithoutHidden, function (branch) {
      return $.inArray(branch.identifier, branchIds) != -1;
    });

    //TODO onChange, fire registered callback - this isn't necessary yet
    TemplateEngine.compile(
      this.selectOptionTmpl,
      this.locationOptions,
      function (content) {
        callback(content);
      }
    );
  }
  enable() {
    $("#" + this.id).prop("disabled", false);
  }
  disable() {
    $("#" + this.id).attr("disabled", "disabled");
  }
  hide() {
    $("label[for='" + this.id + "']").hide();
    $("#" + this.id).hide();
  }
  show() {
    $("label[for='" + this.id + "']").show();
    $("#" + this.id).show();
  }
  setDefaultSelection() {
    const defaultPickupBranch = ApplicationData.getUserDefaultPickupBranch();
    if(this.locationOptions.find(({identifier}) => parseInt(identifier) === defaultPickupBranch)) {
      $("#" + this.id).val(defaultPickupBranch);
    }
    else {
      $("#" + this.id).val(this.locationOptions[0].identifier);
    }
  }
  getCurrentSelection() {
    return $("#" + this.id).val();
  }
  setCurrentSelection(value) {
    $("#" + this.id).val(value);
  }
  addEvents() {}
}
